import React, {useState} from 'react';
import {cloneObject, getFormData, inputChangedHandler, prepareFormData, validateForm} from "../shared/utility";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import {Box, ListItemAvatar, ListItemText} from "@material-ui/core";
import ColorSelect from "./ColorSelect";
import {isEmpty} from "underscore";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";


const useStyles = makeStyles((theme) => ({
    heading: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "20px",
        lineHeight: "25px",
        color: "#00AEEF",
        paddingBottom: "8px",
        paddingTop: "10px",
    },
    label: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "flex-end",
        color: "#FEFFFF",
        paddingBottom: "4px"
    },
    formElement: {
        paddingBottom: "8px",
        '& .MuiFormHelperText-contained': {
            marginLeft: "0px",
        },
    },
    buttonProgress: {
        color: green[500],
        marginLeft: theme.spacing(1),
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    button: {
        marginLeft: theme.spacing(1),
    },
    input: {
        backgroundColor: "transparent",
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        color: "#FEFFFF"
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },


    checkboxValue: {
        textTransform: "capitalize"
    },


    colorWrapper: {
        display: "flex"
    },
    colorBoxWrapper: {
        height: "30px",
        boxSizing: "border-box",
        borderRadius: "2px",
        border: "1px solid #222",
        marginRight: "8px",
        width: "48px",
        overflow: "visible",
        fontSize: '16px',
        lineHeight: '20px',

        '& .color-box1': {
            height: "28px",
        },
        '& .color-box2': {
            height: "14px",
        },
        '& .color-box3': {
            height: "9.3px",
        },
        '& .color-box4': {
            height: "7px",
        }
    },
    select: {
        display: "flex",
    },

}));


let formData = {
    controls: {
        uvc: {
            label: 'Trim',
            value: '',
            validation: {
                presence: {allowEmpty: false}
            },
            valid: true,
            touched: false,
            visible: false

        },
        exteriorColor: {
            label: 'Exterior Color',
            value: '',
            validation: {
                presence: {allowEmpty: false}
            },
            valid: true,
            touched: false,
            visible: false
        },
        interiorColor: {
            label: 'Interior Color',
            value: '',
            validation: {
                presence: {allowEmpty: false}
            },
            valid: true,
            touched: false,
            visible: false
        },
        options: {
            label: 'Options',
            value: '',
            validation: {
                presence: {allowEmpty: true}
            },
            valid: true,
            touched: false,
            visible: false

        },

    },
    loading: false,
    valid: false,
    touched: false,
    generalError: null

}

let formCheckboxData = {
    controls: {},

    loading: false,
    valid: true,
    touched: false,
    generalError: null

}

const SelectOptionsForm = (props) => {

    const classes = useStyles();
    const [formState, setFormState] = useState(formData);
    const [formCheckboxState, setFormCheckboxState] = useState(formCheckboxData);
    const [checkboxElements, setCheckboxElements] = useState([]);


    React.useEffect(() => {
        let uvc = ''
        if (props.trims.length === 1) {
            uvc = props.trims[0].uvc
        }
        let state = {uvc: uvc, exteriorColor: '', interiorColor: ''}
        state.uvc = props.vehicle.uvc
        state.mileage = props.vehicle.mileage
        state.titleStatus = props.vehicle.titleStatus
        state.listedPrice = props.vehicle.listedPrice
        state.postLink = props.vehicle.postLink
        if (props.vehicle.exteriorColor && props.vehicle.exteriorColor.name) {
            state.exteriorColor = props.vehicle.exteriorColor.name
        }
        if (props.vehicle.interiorColor && props.vehicle.interiorColor.name) {
            state.interiorColor = props.vehicle.interiorColor.name
        }


        formData = prepareFormData(formData, state);
        setFormState(formData);
    }, [props.vehicle.vin])


    React.useEffect(() => {
        if (props.trims.length > 0 && formState.controls.uvc.value) {

            const vehicleTrimData = props.trims.find((element) => element.uvc === formState.controls.uvc.value)
            const elements = prepareCheckboxes(vehicleTrimData)
            formCheckboxData.controls = {}
            elements.forEach((element) => {
                console.log(elements, props.vehicle.options)
                formCheckboxData.controls[element[0]] = element[1]
                if (!isEmpty(props.vehicle.options) && props.vehicle.options.hasOwnProperty(element[0])) {
                    formCheckboxData.controls[element[0]].value = props.vehicle.options[element[0]].value
                }
            })

            formCheckboxData = prepareFormData(formCheckboxData);
            setFormCheckboxState(formCheckboxData);
            setCheckboxElements(elements)


        }
    }, [formState.controls.uvc.value])


    const submitHandler = async (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            const data = {}
            const formData = getFormData(formState)
            const optionsValues = getFormData(formCheckboxState)
            const options = {}

            if (optionsValues) {
                for (let optionKey in optionsValues) {
                    const optionData = checkboxElements.find(el => el[0] === optionKey)
                    options[optionKey] = {
                        ...optionData[1],
                        label: formCheckboxData.controls[optionKey].label,
                        value: optionsValues[optionKey],
                        default: formCheckboxData.controls[optionKey].disabled
                    }
                }
            }
            data.uvc = formData.uvc
            data.exteriorColor = formData.exteriorColor
            data.interiorColor = formData.interiorColor
            data.options = options
            props.onNext(data)

        }
    }


    const uvcField = formState.controls.uvc;
    const exteriorColorField = formState.controls.exteriorColor;
    const interiorColorField = formState.controls.interiorColor;
    let trimElement
    let colorElement
    let interiorColorElement


    const changeTrimHandler = async (event) => {
        event.preventDefault();
        const trim = props.trims.find((element) => element.uvc === event.target.value)
        const uvc = (trim && trim.uvc) ? trim.uvc : ''
        props.onBlackBookColorRequest(uvc)
        const formStateUpdated = cloneObject(formState)
        setFormState(formStateUpdated)
        inputChangedHandler(formStateUpdated, setFormState, event.target.value, formState.controls.uvc.key)

    }

    if (props.trims.length === 0) {
        trimElement = <TextField
            name={uvcField.key}
            value={uvcField.value}
            type={'input'}
            //label={uvcField.label}
            fullWidth
            onChange={event => inputChangedHandler(formState, setFormState, event.target.value, uvcField.key)}
            helperText={uvcField.helperText}
            error={!uvcField.valid && uvcField.touched}
            margin="dense"
            variant="outlined"
            InputProps={{
                className: classes.input,
            }}
        />
    } else if (props.trims.length > 0) {
        trimElement = <FormControl className={classes.formControl} fullWidth
                                   error={!uvcField.valid} margin={"normal"}>
            <Select
                labelId="{uvcField.key}-label"
                id={uvcField.key}
                value={uvcField.value}
                displayEmpty
                onChange={event => changeTrimHandler(event)}
                error={!uvcField.valid && uvcField.touched}
                disabled={props.trims.length === 1}
                margin="dense"
                variant="outlined"
                className={classes.input}
            >
                <MenuItem value="">
                    <em>--Select--</em>
                </MenuItem>
                {props.trims.map((item, index) => {
                    const trim = []
                    if (item.series) {
                        trim.push(item.series)
                    }
                    if (item.style) {
                        trim.push(item.style)
                    }
                    return <MenuItem value={item.uvc} key={index}>{trim.join(' ')}</MenuItem>
                })
                }

            </Select>
            <FormHelperText>{uvcField.helperText}</FormHelperText>
        </FormControl>

    }
    let isColorTextField = true
    let isInteriorColorTextField = true
    if (props.trims.length > 0) {
        if (props.exteriorColors.length > 0) {
            isColorTextField = false
        }
        if (props.interiorColors.length > 0) {
            isInteriorColorTextField = false
        }
    }

    if (isColorTextField) {
        colorElement = <ColorSelect
            name={exteriorColorField.key}
            value={exteriorColorField.value}
            type={'input'}
            label={exteriorColorField.label}
            fullWidth
            margin="dense"
            variant="outlined"
            className={'myClass'}
            onChange={(event, newValue) => {
                if (newValue)
                    inputChangedHandler(formState, setFormState, newValue, exteriorColorField.key)
            }}
            onInputChange={(event, newInputValue) => {
                inputChangedHandler(formState, setFormState, newInputValue, exteriorColorField.key)

            }}
            inputValue={exteriorColorField.value}
            helperText={exteriorColorField.helperText}
            error={!exteriorColorField.valid && exteriorColorField.touched}

        />
    } else {
        colorElement = <FormControl className={classes.formControl} fullWidth
                                    error={!exteriorColorField.valid && exteriorColorField.touched} margin={"normal"}>
            <Select
                labelId={`${exteriorColorField.key}-label`}
                id={exteriorColorField.key}
                value={exteriorColorField.value}
                displayEmpty
                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, exteriorColorField.key)}
                error={!exteriorColorField.valid && exteriorColorField.touched}
                classes={{select: classes.select}}
                margin="dense"
                variant="outlined"
                className={classes.input}
            >
                <MenuItem value="">
                    <em>--Select--</em>
                </MenuItem>

                {props.exteriorColors.map((item, index) => {
                    let colors = []
                    for (let i in item.swatch_list) {
                        colors.push(<Box key={i} className={'color-box' + item.swatch_list.length} style={{
                            backgroundColor: item.swatch_list[i],

                        }}/>)
                    }
                    return <MenuItem value={item.name}
                                     key={index}><ListItemAvatar
                        className={classes.colorWrapper}><Box
                        className={classes.colorBoxWrapper}>{colors}</Box></ListItemAvatar><ListItemText
                        primary={item.name} disableTypography={true}/></MenuItem>
                })
                }

            </Select>
            <FormHelperText>{exteriorColorField.helperText}</FormHelperText>
        </FormControl>
    }

    if (isInteriorColorTextField) {
        interiorColorElement = <ColorSelect
            name={interiorColorField.key}
            type={'input'}
            label={interiorColorField.label}
            fullWidth
            margin="dense"
            variant="outlined"
            className={classes.input}
            onChange={(event, newValue) => {
                if (newValue)
                    inputChangedHandler(formState, setFormState, newValue, interiorColorField.key)
            }}
            onInputChange={(event, newInputValue) => {
                inputChangedHandler(formState, setFormState, newInputValue, interiorColorField.key)

            }}
            inputValue={interiorColorField.value}
            helperText={interiorColorField.helperText}
            error={!interiorColorField.valid && interiorColorField.touched}
        />
    } else {


        interiorColorElement = <FormControl className={classes.formControl} fullWidth
                                            error={!interiorColorField.valid && interiorColorField.touched}
                                            margin={"normal"}>
            <Select
                labelId={`${interiorColorField.key}-label`}
                id={interiorColorField.key}
                value={interiorColorField.value}
                displayEmpty
                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, interiorColorField.key)}
                error={!interiorColorField.valid && interiorColorField.touched}
                classes={{select: classes.select}}
                margin="dense"
                variant="outlined"
                className={classes.input}
            >
                <MenuItem value="">
                    <em>--Select--</em>
                </MenuItem>
                {props.interiorColors.map((item, index) => {
                    let colors = []
                    for (let i in item.swatch_list) {
                        colors.push(<Box key={i} className={'color-box' + item.swatch_list.length} style={{
                            backgroundColor: item.swatch_list[i],

                        }}/>)
                    }
                    return <MenuItem value={item.name}
                                     key={index}><ListItemAvatar
                        className={classes.colorWrapper}><Box
                        className={classes.colorBoxWrapper}>{colors}</Box></ListItemAvatar><ListItemText
                        primary={item.name} disableTypography={true}/></MenuItem>
                })
                }

            </Select>
            <FormHelperText>{interiorColorField.helperText}</FormHelperText>
        </FormControl>
    }


    const formElementsVehicle = []
    const formElementsPost = []
    for (let key in formState.controls) {
        let el = formState.controls[key]
        let element
        if (el.type === 'input') {
            element = <TextField
                key={key}
                name={key}
                value={el.value}
                type={'input'}
                fullWidth
                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, key)}
                helperText={el.helperText}
                error={!el.valid && el.touched}
                margin="dense"
                variant="outlined"
                InputProps={{
                    className: classes.input,
                }}
            />
        } else if (el.type === 'dropdown') {
            element = <FormControl className={classes.formControl} fullWidth
                                   error={!el.valid && el.touched} margin={"normal"} key={key}>
                <Select
                    key={key}
                    labelId="{conditionField.key}-label"
                    id={el.key}
                    value={el.value}
                    displayEmpty
                    onChange={event => inputChangedHandler(formState, setFormState, event.target.value, el.key)}
                    error={!el.valid && el.touched}
                    margin="dense"
                    variant="outlined"
                    className={classes.input}
                >
                    {el.values.map((item, i) => (
                        <MenuItem key={key + i} value={item.key}>{item.value}</MenuItem>
                    ))}
                </Select>
                <FormHelperText>{!el.valid && el.touched ? el.helperText : ""}</FormHelperText>
            </FormControl>
        }

        if (el.group === 'vehicle') {
            formElementsVehicle.push(element)
        } else if (el.group === 'post') {
            formElementsPost.push(element)
        }
    }


    return (
        <React.Fragment>
            {props.app.error &&
            <div className={classes.wrapper}>
                <Alert severity="error">{props.app.error ?? ''}</Alert>
            </div>
            }
            <form className={classes.form} noValidate onSubmit={submitHandler}>
                <Box className={classes.heading}>Vehicle Details</Box>
                <Box className={classes.formElement}>
                    <Box className={classes.label}>Select Trim</Box>
                    {trimElement}
                </Box>
                <Box className={classes.formElement}>
                    <Box className={classes.label}>Exterior Color</Box>
                    {colorElement}
                </Box>
                <Box className={classes.formElement}>
                    <Box className={classes.label}>Interior Color</Box>
                    {interiorColorElement}
                </Box>
                {checkboxElements.length > 0 &&
                <Box className={classes.heading}>Premium Options</Box>
                }
                {checkboxElements.map((item) => {
                    return (
                        <Box key={item[0]}>
                            <FormControlLabel
                                className={classes.checkboxValue}
                                control={<Checkbox

                                    color={'primary'}
                                    checked={formCheckboxState.controls[item[0]].value === true}
                                    disabled={formCheckboxState.controls[item[0]].disabled}
                                    onChange={() => inputChangedHandler(formCheckboxState, setFormCheckboxState, !formCheckboxState.controls[item[0]].value, item[0])}
                                />}
                                label={item[1].label}
                            />
                        </Box>)
                })
                }
            </form>

            <Box display="flex" justifyContent="flex-end" style={{marginTop: '16px', marginBottom: '30px'}}>
                <div className={classes.wrapper}>
                    <Button className={classes.button} type={"button"} variant={"outlined"} onClick={props.onBack}
                    >  {props.backButton}</Button>

                    <Button
                        className={classes.button}
                        type={"button"}
                        variant={"contained"}
                        color={"primary"}
                        onClick={submitHandler}
                    > Next {props.app.loading &&
                    <CircularProgress size={24} className={classes.buttonProgress}/>}</Button>

                </div>
            </Box>

        </React.Fragment>

    );

}


export default SelectOptionsForm;

const prepareCheckboxes = (vehicleTrimData) => {

    if (vehicleTrimData === undefined) {
        return []
    }

    const standardOptions = ['moon_sunroof', 'entertain', 'navigation', 'airbags']
    const checkboxes = {}
    standardOptions.forEach(value => {
        if (vehicleTrimData.hasOwnProperty(value)) {
            checkboxes[value] = {
                label: value.replace('_', ' ') + ': ' + vehicleTrimData[value],
                value: true,
                disabled: true,
                type: 'checkbox',
                auto: null,
                clean: null,
                avg: null,
                rough: null,
                xclean: null

            }
        }
    })

    if (vehicleTrimData.hasOwnProperty('add_deduct_list')) {
        vehicleTrimData.add_deduct_list.forEach(element => {
            if (element.name) {
                let checked = false
                let disabled = false
                if (element.auto === 'Y' || element.auto === 'M') {
                    checked = true
                    disabled = element.auto === 'M';
                }
                checkboxes[element.uoc] = {
                    label: element.name,
                    value: checked,
                    disabled: disabled,
                    type: 'checkbox',
                    auto: element.auto,
                    clean: element.clean,
                    avg: element.avg,
                    rough: element.rough,
                    xclean: element.xclean
                }
            }
        })
    }

    const elements = Object.entries(checkboxes)
    elements.sort((a, b) => {
        const el1 = a[1]
        const el2 = b[1]
        if (!el1.disabled && el2.disabled) {
            return 1
        }
        if (el1.disabled && !el2.disabled) {
            return -1
        }
        if (el1.disabled === el2.disabled) {
            if (el1.label.toLowerCase() < el2.label.toLowerCase()) {
                return -1
            }
            if (el1.label.toLowerCase() > el2.label.toLowerCase()) {
                return 1
            }
            if (el1.label.toLowerCase() === el2.label.toLowerCase()) {
                return 0
            }
        } else {
            return 1
        }
    })

    return elements

}
